import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { Box, ChakraProvider, Text } from "@chakra-ui/react";
import theme from "../../../theme/theme";
import { BillingProvider } from "../../../contexts/BillingContext";
import { isDemoEntryAnalysisEnabled } from "../../../utils/demoEntryAnalysisFeatureFlag";
import { DEMO_ENTRY_ANALYSIS_BASE_PATH } from "../../../utils/demoEntryAnalysisSession";
import DemoImportPage from "./DemoImportPage";
import DemoWizardPage from "./DemoWizardPage";
import DemoGeneratingPage from "./DemoGeneratingPage";
import DemoResultsPage from "./DemoResultsPage";

function DemoDisabled(): React.ReactElement {
  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" p={8}>
      <Text fontFamily="'IBM Plex Sans', sans-serif" color="gray.500">
        Demo Entry Analysis is not enabled.
      </Text>
    </Box>
  );
}

/**
 * Public (and post-auth results) router for `/demo/entry-analysis/*`.
 * Mount outside ProtectedRoute so import/prep work without Clerk.
 * ChakraProvider required so report Card `_dark` chrome matches next-themes.
 */
export default function DemoEntryAnalysisApp(): React.ReactElement {
  const location = useLocation();

  if (!isDemoEntryAnalysisEnabled()) {
    return <DemoDisabled />;
  }

  return (
    <ChakraProvider theme={theme as any} resetCss={false} w="100%" {...({} as any)}>
      <BillingProvider>
        <Switch>
        <Route exact path={DEMO_ENTRY_ANALYSIS_BASE_PATH} component={DemoImportPage} />
        <Route exact path={`${DEMO_ENTRY_ANALYSIS_BASE_PATH}/wizard`} component={DemoWizardPage} />
        <Route
          exact
          path={`${DEMO_ENTRY_ANALYSIS_BASE_PATH}/generating`}
          component={DemoGeneratingPage}
        />
        <Route exact path={`${DEMO_ENTRY_ANALYSIS_BASE_PATH}/results`} component={DemoResultsPage} />
        <Redirect
          to={{
            pathname: DEMO_ENTRY_ANALYSIS_BASE_PATH,
            search: location.search,
          }}
        />
      </Switch>
      </BillingProvider>
    </ChakraProvider>
  );
}
